import * as React from 'react';
import * as styles from './styles.css';
export interface ISectionProps {
  marginTop?: number;
  marginBottom?: number;
  marginRight?: number;
  marginLeft?: number;
  display?: 'block' | 'flex';
  alignItems?: 'center';
  justifyContent?: 'center';
  children?: React.ReactNode;
}

export const Block: React.FC<ISectionProps> = props => {
  const { children, ...rest } = props;

  return (
    <div className={styles['block']} style={rest}>
      {children}
    </div>
  );
};

Block.displayName = 'Section';
